<template>
  <div class="game-stats">
    <ContentBlock>
      <div slot="instructions">
        <h4 class="gametitle f3">{{ stat.game.title }}</h4>
        <i18n class="createdat" tag="p" path="Available on SpringboardVR since {date}.">
          <span slot="date">{{ createdAt }}</span>
        </i18n>
      </div>
      <div class="block">
        <div v-if="!generatedAt" class="empty">
          <p class="f5">{{ $t('This game wasn’t available on SpringboardVR at the time you selected.') }}</p>
        </div>
        <div v-else class="grid">
          <template class="pricestats" v-if="!$permissions['enterprise-developer']">
            <div>
              <h6 v-if="isCurrentDate" class="f6 currentrevenuelabel">{{ type === 'month' ? $t('Current Month Revenue') : $t('Current Year Revenue')}}*</h6>
              <h6 v-else class="currentrevenuelabel f6">{{ type === 'month' ? $t('Month Revenue') : $t('Year Revenue')}}*</h6>
              <span class="statvalue f3 currentrevenue">{{ stat.currentRevenue || $t('Unknown') }}</span>
            </div>
            <div v-if="isCurrentDate">
              <h6 class="estimatedrevenuelabel f6">
                {{ type === 'month' ? $t('Estimated Month Revenue') : $t('Estimated Year Revenue')}}*
              </h6>
              <span class="statvalue f3 estimatedrevenue">{{ stat.estimatedRevenue || $t('Unknown') }}</span>
            </div>
          </template>
          <div>
            <h6 class="f6">{{ $t('Total Minutes') }}</h6>
            <span class="statvalue f3 totalminutes">{{ stat.totalMinutes || $t('Unknown') }}</span>
          </div>
          <div>
            <h6 class="f6">{{ $t('Average Session Time (min)') }}</h6>
            <span class="statvalue f3 averagesessiontime">{{ stat.averageSessionTime || $t('Unknown') }}</span>
          </div>
          <div>
            <h6 class="f6">{{ $t('Number of Organizations') }}</h6>
            <span class="statvalue f3 locationcount">{{ stat.numberOfLocations || $t('Unknown') }}</span>
          </div>
          <div>
            <h6 class="f6">{{ $t('Number of Stations') }}</h6>
            <span class="statvalue f3 stationcount">{{ stat.numberOfStations || $t('Unknown') }}</span>
          </div>
        </div>
      </div>
      <div slot="additional" v-if="generatedAt">
        <p class="updatedat f7"> {{ $t('Latest Update') }}: {{ generatedAt || '-' }}
        </p>
        <p class="updatedat">
          <slot name="additional"></slot>
        </p>
      </div>

    </ContentBlock>
  </div>
</template>

<script>
import Vue from 'vue';
import ContentBlock from '@/core/shared/components/ContentBlock';
import Component from 'vue-class-component';
import moment from 'moment';
@Component({
  components: {
    ContentBlock,
  },
  props: {
    type: {
      required: true,
      type: String,
    },
    isCurrentDate: {
      required: true,
      type: Boolean,
    },
    stat: {
      required: true,
      type: Object,
    },
  },
})
export default class GameStats extends Vue {
  get createdAt () {
    return moment(this.stat.contentOwnership.createdAt).format('LL');
  }

  get generatedAt () {
    const momentDate = moment(this.stat.generatedAt);
    return momentDate.isValid() ? momentDate.format('LL') : null;
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.game-stats {

  & h6, & .gametitle {
    margin: 0;
    margin-bottom: var(--spacingXS);
  }
  & .statvalue {
    margin: 0;
  }
  & .availability {
    color: var(--colorGrey);
  }
  & .grid {
    display: grid;
    justify-content: space-between;
    grid-gap: var(--spacingMd);
    grid-template-columns: repeat(2, auto);
    @media(--tablet) {
      grid-template-columns: repeat(3, minmax(33%, auto));
    }
    /* grid-template-columns: repeat(auto-fit, minmax(33%, 1fr) ); */
  }
  & .empty {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & .updatedat {
    margin-top: var(--spacingSm);
    color: var(--colorManatee);
    font-style: italic;
  }
}
</style>
